import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import IndentEditing from './indentationediting';

export default class Indentation extends Plugin {
  static get requires() {
    return [ IndentEditing ];
  }

  static get pluginName() {
    return 'Indentation';
  }
}
